const initialState = {
  //   profile: null,
  profile: localStorage.getItem("profile")
    ? JSON.parse(localStorage.getItem("profile"))
    : null,
};

function profileReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_PROFILE":
      return {
        ...state,
        profile: {...action.payload},
      };
    default:
      return state;
  }
}

export default profileReducer;
